export default class AdminsitrativeCentreFACeB2B {
  /** @type {string} */ Code = null
  /** @type {string} */ Name = null
  /** @type {string} */ Role = null
}
